import React from 'react';
import Banner from '../components/banner/Banner';
import CoinsTable from '../components/CoinsTable';

const Homepage = () => {
  return <>
  <Banner />
  <CoinsTable />
  </>;
};

export default Homepage;
